/**
 * Created by dkotsiko on 11/6/16.
 */

import './util/magpie-util';
import './structure/magpie-structure';
import './flow/magpie-flow';
import './security/magpie-security';
import './profiling/magpie-profiling';
import './lineage/magpie-lineage';
import './inference/magpie-inference';
import './results/magpie-results';
import './clusters/magpie-clusters';
import './validation/magpie-validation';
import './exports/magpie-exported-datasource-file';
import './file-upload/magpie-file-upload';

angular.module('magpieDisplay', [
  'ngRoute',
  'ngAnimate',
  'ngTouch',
  'magpieUtil',
  'magpieStructure',
  'magpieFlow',
  'magpieSecurity',
  'magpieProfiling',
  'magpieLineage',
  'magpieInference',
  'magpieResults',
  'magpieClusters',
  'magpieValidation',
  'magpieExportedDataSourceFile',
  'magpieFileUpload'
]).
directive('magpieInfo', function() {
  return {
    restrict: 'E',
    scope: {
      info: '='
    },
    templateUrl: 'components/magpie-display/info.html'
  };
}).
directive('magpieHelp', function() {
  return {
    restrict: 'E',
    scope: {
      message: '='
    },
    templateUrl: 'components/magpie-display/help.html'
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/magpie-display.js